/**
 * JWNET（WEB）データ取込
 */
import Vue from 'vue'
import * as httpConst from '../../../constants/httpConst'
import * as types from '../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/transfers`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      /* マニフェスト番号 */
      manifest_no: null,
      /* 照会日(開始日) */
      import_from_date: null,
      /* 照会日(終了日) */
      import_to_date: null,
      /* 引渡し日(開始日) */
      collected_from_date: null,
      /* 引渡し日(終了日) */
      collected_to_date: null,
      /* 加入者番号 */
      subscriber_number: null,
      /* 排出事業者名 */
      emission_name: null,
      /* 排出事業場名 */
      emission_location_name: null,
      // /* 収集運搬業者(加入者番号) */
      // transporter_subscriber_number: null,
      /* 収集運搬業者(名称) */
      transporter_name: null,
      // /* 処分場(id) */
      // disposer_id: null,
      // /* 処分場(加入者番号) */
      // disposer_subscriber_number: null,
      /* 処分事業者(名称) */
      disposer_name: null,
      // /* 処分事業場コード */
      // trader_location_key: null,
      /* 処分事業場(名称) */
      disposer_location_name: null,
      /* JWNET取扱品目 */
      item_ids: [],
      /* 運搬報告状況 */
      transport_report_state: null,
      /* 運搬終了日(開始日) */
      transport_completed_from_date: null,
      /* 運搬終了日(終了日) */
      transport_completed_to_date: null,
      /* 運搬報告区間指定 */
      section_no: null,
      /* 取込済みを含む */
      with_imported: false,
      /* 非表示を含む */
      with_hidden: false,
      /* 処分報告状況 */
      disposal_report_state: null,
      /* 処分終了日(開始日) */
      disposal_completed_from_date: null,
      /* 処分終了日(終了日) */
      disposal_completed_to_date: null,
      /* 最終報告状況 */
      final_report_state: null,
      /* 最終終了日(開始日) */
      final_disposal_from_date: null,
      /* 最終終了日(終了日) */
      final_disposal_to_date: null,
      /* 表示順 */
      sort_type: 'updated_date_desc',
      /* 完全一致済み */
      exact_matched: false,
      /* 排出業者一致済み */
      emission_matched: false,
      /* 処分業者一致済み */
      disposer_matched: false,
      /* 未紐付け(排出事業者) */
      supplierable_state_unlinked: false,
      /* 未紐付け(業者) */
      trader_state_unlinked: false,
      /* 未紐付け(報告不要業者) */
      none_reporting_state_unlinked: false,
      /* 未紐付け(公共事業場) */
      public_place_state_unlinked: false,
      /* 表示件数 */
      limit: 50,
    },
  }
}

const transfer = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * JWNETデータ取込一覧検索
     * @param dispatch
     * @param commit
     * @param state
     * @param params
     * @param page
     * @returns {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { params, page }) {
      dispatch('saveCondition', { params: params })
      const parameters = {
        manifest_no: state.condition.manifest_no,
        import_from_date: state.condition.import_from_date,
        import_to_date: state.condition.import_to_date,
        collected_from_date: state.condition.collected_from_date,
        collected_to_date: state.condition.collected_to_date,
        subscriber_number: state.condition.subscriber_number,
        emission_name: state.condition.emission_name,
        emission_location_name: state.condition.emission_location_name,
        // transporter_subscriber_number: state.condition.transporter_subscriber_number,
        transporter_name: state.condition.transporter_name,
        // disposer_id: state.condition.disposer_id,
        // disposer_subscriber_number: state.condition.disposer_subscriber_number,
        disposer_name: state.condition.disposer_name,
        // trader_location_key: state.condition.trader_location_key,
        disposer_location_name: state.condition.disposer_location_name,
        item_ids: state.condition.item_ids,
        transport_report_state: state.condition.transport_report_state,
        transport_completed_from_date: state.condition.transport_completed_from_date,
        transport_completed_to_date: state.condition.transport_completed_to_date,
        section_no: state.condition.section_no,
        with_imported: state.condition.with_imported,
        with_hidden: state.condition.with_hidden,
        disposal_report_state: state.condition.disposal_report_state,
        disposal_completed_from_date: state.condition.disposal_completed_from_date,
        disposal_completed_to_date: state.condition.disposal_completed_to_date,
        final_report_state: state.condition.final_report_state,
        final_disposal_from_date: state.condition.final_disposal_from_date,
        final_disposal_to_date: state.condition.final_disposal_to_date,
        sort_type: state.condition.sort_type,
        exact_matched: state.condition.exact_matched,
        emission_matched: state.condition.emission_matched,
        disposer_matched: state.condition.disposer_matched,
        supplierable_state_unlinked: state.condition.supplierable_state_unlinked,
        trader_state_unlinked: state.condition.trader_state_unlinked,
        none_reporting_state_unlinked: state.condition.none_reporting_state_unlinked,
        public_place_state_unlinked: state.condition.public_place_state_unlinked,

        limit: state.condition.limit,
        page: page,
      }
      commit(types.DRIVER_TRANSFER_RESET_PAGINATION);
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: parameters }).then(data => {
          let content = data.content
          commit(types.DRIVER_TRANSFER_PAGINATION, { content })
          resolve(content)
        })
      })
    },
    /**
     *
     * @param commit
     * @param id
     * @returns {Promise<unknown>}
     */
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          const content = data.content;
          resolve(data.content)
        })
      })
    },
    /**
     *
     * @param dispatch
     * @param commit
     * @param state
     * @param params { Object }
     * @returns {Promise<unknown>}
     */
    create ({ dispatch, commit, state }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    /**
     *
     * @param commit
     * @param params
     * @returns {Promise<unknown>}
     */
    update ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.put(API_PATH, params).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    saveCondition ({ commit, state }, { params }) {
      /* マニフェスト番号 */
      const _manifest_no = (params.manifest_no !== undefined) ? params.manifest_no : state.condition.manifest_no;
      /* 照会日(開始日) */
      const _import_from_date = (params.import_from_date !== undefined) ? params.import_from_date : state.condition.import_from_date;
      /* 照会日(終了日) */
      const _import_to_date = (params.import_to_date !== undefined) ? params.import_to_date : state.condition.import_to_date;
      /* 引渡し日(開始日) */
      const _collected_from_date = (params.collected_from_date !== undefined) ? params.collected_from_date : state.condition.collected_from_date;
      /* 引渡し日(終了日) */
      const _collected_to_date = (params.collected_to_date !== undefined) ? params.collected_to_date : state.condition.collected_to_date;
      /* 加入者番号 */
      const _subscriber_number = (params.subscriber_number !== undefined) ? params.subscriber_number : state.condition.subscriber_number;
      /* 排出事業者名 */
      const _emission_name = (params.emission_name !== undefined) ? params.emission_name : state.condition.emission_name;
      /* 排出事業場名 */
      const _emission_location_name = (params.emission_location_name !== undefined) ? params.emission_location_name : state.condition.emission_location_name;
      // /* 収集運搬業者(加入者番号) */
      // const _transporter_subscriber_number = (params.transporter_subscriber_number !== undefined) ? params.transporter_subscriber_number : state.condition.transporter_subscriber_number;
      /* 収集運搬業者(名称) */
      const _transporter_name = (params.transporter_name !== undefined) ? params.transporter_name : state.condition.transporter_name;
      // /* 処分場(id) */
      // const _disposer_id = (params.disposer_id !== undefined) ? params.disposer_id : state.condition.disposer_id;
      // /* 処分場(加入者番号) */
      // const _disposer_subscriber_number = (params.disposer_subscriber_number !== undefined) ? params.disposer_subscriber_number : state.condition.disposer_subscriber_number;
      /* 処分事業者(名称) */
      const _disposer_name = (params.disposer_name !== undefined) ? params.disposer_name : state.condition.disposer_name;
      // /* 処分事業場コード */
      // const _trader_location_key = (params.trader_location_key !== undefined) ? params.trader_location_key : state.condition.trader_location_key;
      /* 処分事業場(名称) */
      const _disposer_location_name = (params.disposer_location_name !== undefined) ? params.disposer_location_name : state.condition.disposer_location_name;
      /* JWNET取扱品目 */
      const _item_ids = (params.item_ids !== undefined) ? params.item_ids : state.condition.item_ids;
      /* 運搬報告状況 */
      const _transport_report_state = (params.transport_report_state !== undefined) ? params.transport_report_state : state.condition.transport_report_state;
      /* 運搬終了日(開始日) */
      const _transport_completed_from_date = (params.transport_completed_from_date !== undefined) ? params.transport_completed_from_date : state.condition.transport_completed_from_date;
      /* 運搬終了日(終了日) */
      const _transport_completed_to_date = (params.transport_completed_to_date !== undefined) ? params.transport_completed_to_date : state.condition.transport_completed_to_date;
      /* 運搬報告区間指定 */
      const _section_no = (params.section_no !== undefined) ? params.section_no : state.condition.section_no;
      /* 取込済みを含む */
      const _with_imported = (params.with_imported !== undefined) ? params.with_imported : state.condition.with_imported;
      /* 非表示を含む */
      const _with_hidden = (params.with_hidden !== undefined) ? params.with_hidden : state.condition.with_hidden;
      /* 処分報告状況 */
      const _disposal_report_state = (params.disposal_report_state !== undefined) ? params.disposal_report_state : state.condition.disposal_report_state;
      /* 処分終了日(開始日) */
      const _disposal_completed_from_date = (params.disposal_completed_from_date !== undefined) ? params.disposal_completed_from_date : state.condition.disposal_completed_from_date;
      /* 処分終了日(終了日) */
      const _disposal_completed_to_date = (params.disposal_completed_to_date !== undefined) ? params.disposal_completed_to_date : state.condition.disposal_completed_to_date;
      /* 最終報告状況 */
      const _final_report_state = (params.final_report_state !== undefined) ? params.final_report_state : state.condition.final_report_state;
      /* 最終処分終了日(開始日) */
      const _final_disposal_from_date = (params.final_disposal_from_date !== undefined) ? params.final_disposal_from_date : state.condition.final_disposal_from_date;
      /* 最終処分終了日(終了日) */
      const _final_disposal_to_date = (params.final_disposal_to_date !== undefined) ? params.final_disposal_to_date : state.condition.final_disposal_to_date;
      /* 表示順 */
      const _sort_type = (params.sort_type !== undefined) ? params.sort_type : state.condition.sort_type;
      /* 完全一致済み */
      const _exact_matched = (params.exact_matched !== undefined) ? params.exact_matched : state.condition.exact_matched;
      /* 排出業者一致済み */
      const _emission_matched = (params.emission_matched !== undefined) ? params.emission_matched : state.condition.emission_matched;
      /* 処分業者一致済み */
      const _disposer_matched = (params.disposer_matched !== undefined) ? params.disposer_matched : state.condition.disposer_matched;
      /* 未紐付け(排出事業者) */
      const _supplierable_state_unlinked = (params.supplierable_state_unlinked !== undefined) ? params.supplierable_state_unlinked : state.condition.supplierable_state_unlinked;
      /* 未紐付け(業者) */
      const _trader_state_unlinked = (params.trader_state_unlinked !== undefined) ? params.trader_state_unlinked : state.condition.trader_state_unlinked;
      /* 未紐付け(報告不要業者) */
      const _none_reporting_state_unlinked = (params.none_reporting_state_unlinked !== undefined) ? params.none_reporting_state_unlinked : state.condition.none_reporting_state_unlinked;
      /* 未紐付け(公共事業場) */
      const _public_place_state_unlinked = (params.public_place_state_unlinked !== undefined) ? params.public_place_state_unlinked : state.condition.public_place_state_unlinked;

        /* 表示件数 */
      const _limit = (params.limit !== undefined) ? params.limit : state.condition.limit;
      const _params = {
        manifest_no: _manifest_no,
        import_from_date: _import_from_date,
        import_to_date: _import_to_date,
        collected_from_date: _collected_from_date,
        collected_to_date: _collected_to_date,
        subscriber_number: _subscriber_number,
        emission_name: _emission_name,
        emission_location_name: _emission_location_name,
        // transporter_subscriber_number: _transporter_subscriber_number,
        transporter_name: _transporter_name,
        // disposer_id: _disposer_id,
        // disposer_subscriber_number: _disposer_subscriber_number,
        disposer_name: _disposer_name,
        // trader_location_key: _trader_location_key,
        disposer_location_name: _disposer_location_name,
        item_ids: _item_ids,
        transport_report_state: _transport_report_state,
        transport_completed_from_date: _transport_completed_from_date,
        transport_completed_to_date: _transport_completed_to_date,
        section_no: _section_no,
        with_imported: _with_imported,
        with_hidden: _with_hidden,
        disposal_report_state: _disposal_report_state,
        disposal_completed_from_date: _disposal_completed_from_date,
        disposal_completed_to_date: _disposal_completed_to_date,
        final_report_state: _final_report_state,
        final_disposal_from_date: _final_disposal_from_date,
        final_disposal_to_date: _final_disposal_to_date,
        sort_type: _sort_type,
        exact_matched: _exact_matched,
        supplierable_state_unlinked: _supplierable_state_unlinked,
        trader_state_unlinked: _trader_state_unlinked,
        none_reporting_state_unlinked: _none_reporting_state_unlinked,
        public_place_state_unlinked: _public_place_state_unlinked,
        limit: _limit,
      }
      commit(types.DRIVER_TRANSFER_CONDITION, { _params })
    },
    resetCondition ({ commit }) {
      commit(types.DRIVER_TRANSFER_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.DRIVER_TRANSFER_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.DRIVER_TRANSFER_CONDITION] (state, { _params }) {
      state.condition.manifest_no = _params.manifest_no
      state.condition.import_from_date = _params.import_from_date
      state.condition.import_to_date = _params.import_to_date
      state.condition.collected_from_date = _params.collected_from_date
      state.condition.collected_to_date = _params.collected_to_date
      state.condition.subscriber_number = _params.subscriber_number
      state.condition.emission_name = _params.emission_name
      state.condition.emission_location_name = _params.emission_location_name
      // state.condition.transporter_subscriber_number = _params.transporter_subscriber_number
      state.condition.transporter_name = _params.transporter_name
      // state.condition.disposer_id = _params.disposer_id
      // state.condition.disposer_subscriber_number = _params.disposer_subscriber_number
      state.condition.disposer_name = _params.disposer_name
      // state.condition.trader_location_key = _params.trader_location_key
      state.condition.disposer_location_name = _params.disposer_location_name
      state.condition.item_ids = _params.item_ids
      state.condition.transport_report_state = _params.transport_report_state
      state.condition.transport_completed_from_date = _params.transport_completed_from_date
      state.condition.transport_completed_to_date = _params.transport_completed_to_date
      state.condition.section_no = _params.section_no
      state.condition.with_imported = _params.with_imported
      state.condition.with_hidden = _params.with_hidden
      state.condition.disposal_report_state = _params.disposal_report_state
      state.condition.disposal_completed_from_date = _params.disposal_completed_from_date
      state.condition.disposal_completed_to_date = _params.disposal_completed_to_date
      state.condition.final_report_state = _params.final_report_state
      state.condition.final_disposal_from_date = _params.final_disposal_from_date
      state.condition.final_disposal_to_date = _params.final_disposal_to_date
      state.condition.sort_type = _params.sort_type
      state.condition.exact_matched = _params.exact_matched
      state.condition.supplierable_state_unlinked = _params.supplierable_state_unlinked
      state.condition.trader_state_unlinked = _params.trader_state_unlinked
      state.condition.none_reporting_state_unlinked = _params.none_reporting_state_unlinked
      state.condition.public_place_state_unlinked = _params.public_place_state_unlinked
      state.condition.limit = _params.limit
    },
    [types.DRIVER_TRANSFER_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_TRANSFER_PAGINATION] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_TRANSFER_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
  },
}

export default transfer

